<template>
  <div v-loading="loading" class="content">
    <div class="header">
      <div class="tab">
        <span
          v-for="(item, $index) in tabList"
          :key="$index"
          :class="['tabItem', active === item.type.value ? 'active' : '']"
          @click="changeType(item.type.value)">
          {{ item.type.label }}({{ item.qty }})
        </span>
      </div>
      <div class="header-opt">
        <div class="search">
          <el-input
            v-model="searchVal"
            placeholder="请输入进口商名称\EIN NO"
            class="input-search"
            clearable
            @keydown.enter.native="initList"
            @clear="initList"></el-input>
          <div class="btn-search" @click="initList">
            <i class="el-icon-search"></i>
          </div>
        </div>
        <div class="filter-tab">
          <span
            :class="[
              'tab-item',
              'flex_c_c',
              filterList.isAssigned === '' && 'active',
            ]"
            @click="changeIsAssigned('')">全部</span>
          <span
            :class="['tab-item', 'flex_c_c', filterList.isAssigned && 'active']"
            @click="changeIsAssigned(true)">已分配供应商</span>
          <span
            :class="[
              'tab-item',
              'flex_c_c',
              filterList.isAssigned === false && 'active',
            ]"
            @click="changeIsAssigned(false)">未分配供应商</span>
        </div>
        <div v-permissson="'add'" class="add flex_c_c" @click="dialogVisible1 = true">
          <i class="el-icon-circle-plus-outline"></i>新增
        </div>
        <BaseFilter :isActive="isActive" :width="780" @sendFilter="sendFilter" @reset="reset" @exportData="exportData">
          <el-form ref="form" :model="filterList" label-width="112px">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="状态">
                  <el-select
                    v-model="filterList.status"
                    placeholder="请选择"
                    style="width: 100%"
                    clearable
                    collapse-tags
                    multiple>
                    <el-option
                      v-for="item in config.importerStatusOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="归属">
                  <el-select v-model="filterList.belong" placeholder="请选择" style="width: 100%" clearable>
                    <el-option label="内部" :value="0"></el-option>
                    <el-option label="外部" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="公司">
                  <el-select v-model="filterList.companyIds" placeholder="请选择" filterable clearable style="width: 100%">
                    <el-option
                      v-for="item in companyDrapdown"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="注册时间">
                  <el-date-picker
                    v-model="filterList.registerDate"
                    style="width: 100%"
                    type="daterange"
                    range-separator="-"
                    align="center"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="生效日期">
                  <el-date-picker
                    v-model="filterList.effectiveDate"
                    style="width: 100%"
                    type="daterange"
                    range-separator="-"
                    align="center"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="截止日期">
                  <el-date-picker
                    v-model="filterList.closeDate"
                    style="width: 100%"
                    type="daterange"
                    range-separator="-"
                    align="center"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="创建时间">
                  <el-date-picker
                    v-model="filterList.createdOn"
                    style="width: 100%"
                    type="daterange"
                    range-separator="-"
                    align="center"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="报税截止时间">
                  <el-date-picker
                    v-model="filterList.bondedDeadlineDate"
                    style="width: 100%"
                    type="daterange"
                    range-separator="-"
                    align="center"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="年审截止时间">
                  <el-date-picker
                    v-model="filterList.yearAuditDeadlineDate"
                    style="width: 100%"
                    type="daterange"
                    range-separator="-"
                    align="center"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="BOI是否">
                  <el-select v-model="filterList.isBOI" placeholder="请选择" clearable style="width: 100%">
                    <el-option label="是" :value="true"></el-option>
                    <el-option label="否" :value="false"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="月结是否">
                  <el-select v-model="filterList.isMonthEnd" placeholder="请选择" clearable style="width: 100%">
                    <el-option label="是" :value="true"></el-option>
                    <el-option label="否" :value="false"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否禁用">
                  <el-select v-model="filterList.isActived" placeholder="请选择" clearable style="width: 100%">
                    <el-option label="是" :value="true"></el-option>
                    <el-option label="否" :value="false"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="敏感进口商">
                  <el-select v-model="filterList.isSensitiveImporter" placeholder="请选择" clearable style="width: 100%">
                    <el-option label="是" :value="true"></el-option>
                    <el-option label="否" :value="false"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否注销">
                  <el-select v-model="filterList.isCancel" placeholder="请选择" clearable style="width: 100%">
                    <el-option label="是" :value="true"></el-option>
                    <el-option label="否" :value="false"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Surety Code">
                  <el-select v-model="filterList.suretyCode" filterable clearable placeholder="请选择" style="width: 100%">
                    <el-option label="054" value="054"></el-option>
                    <el-option label="856" value="856"></el-option>
                    <el-option label="036" value="036"></el-option>
                    <el-option label="300" value="300"></el-option>
                    <el-option label="846" value="846"></el-option>
                    <el-option label="873" value="873"></el-option>
                    <el-option label="128" value="128"></el-option>
                    <el-option label="664" value="664"></el-option>
                    <el-option label="353" value="353"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="买BOND代理">
                  <el-select
                    v-model="filterList.bondSupplierId"
                    placeholder="请选择"
                    style="width: 100%"
                    filterable
                    clearable>
                    <el-option
                      v-for="item in supplierOptions"
                      :key="item.id"
                      :label="item.code + '-' + item.wbName"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="EIN号码">
                  <el-input v-model="filterList.taxNo" style="width: 100%" placeholder="请输入EIN"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="法人">
                  <el-input
                    v-model="contactsInput"
                    style="width: 100%"
                    placeholder="请输入法人名称，多个用分号隔开 多个查询必须精确 单个可以模糊"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </BaseFilter>
      </div>
    </div>
    <div class="data">
      <BaseTable
        v-if="height"
        :height="height"
        :tableData="{
          ...tableData,
          fileds,
        }"
        :pageIndex="pager.pageIndex"
        :pageSize="pager.pageSize"
        :border="true"
        @handlePageChange="handlePageChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChange="sortChange">
        <span slot="status" slot-scope="row" :class="['status', `status${row.scope.status}`, 'flex_c_c']">
          {{ formatStatus(row.scope) }}
        </span>
        <template slot="belong" slot-scope="row">
          <span :class="['belong', `belong${row.scope.belong}`, 'flex_c_c']">
            {{ row.scope.belongName }}
          </span>
          <div style="margin-top: 6px;color: #423169;">
            客户数({{ row.scope.companyNumber }})
            <!-- 编辑图标（始终显示） -->
            <i
              class="el-icon-edit-outline"
              style="cursor: pointer; color: #67C23A; margin-left: 4px;"
              title="分配客户"
              @click="companyRow(row.scope, false)">
            </i>
          </div>
          <div v-if="row.scope.companyNumber <= 3" style="margin-top: 6px;color: #666666;">
            <div v-for="(item, index) in row.scope.companyNames" :key="index">
              <!-- 智能取值：兼容字符串/对象，过滤无效值 -->
              {{ (typeof item === 'string' ? item : '') }}
            </div>
          </div>
        </template>
        <template slot="countryName" slot-scope="row">
          <div class="address-row">
            <div class="mark-item">
              <span class="label label5 flex_c_c">国家</span>
              <span class="value">{{ row.scope.countryName }}</span>
            </div>
            <div class="mark-item">
              <span class="label label5 flex_c_c">省州</span>
              <span class="value">{{ row.scope.provinceEnName }}</span>
            </div>
            <div class="mark-item">
              <span class="label label5 flex_c_c">城市</span>
              <span class="value">{{ row.scope.cityAddress }}</span>
            </div>
            <div class="mark-item">
              <span class="label label5 flex_c_c">邮编</span>
              <span class="value">{{ row.scope.postcode || "--" }}</span>
            </div>
          </div>
          <div class="mark-item" style="margin-top: 12px">
            <span class="label label5 flex_c_c">地址</span>
            <span class="value">{{ row.scope.address }}</span>
          </div>
        </template>
        <template slot="createdOn" slot-scope="row">
          <div class="mark-item">
            <span class="label label6 flex_c_c">创建人</span>
            <span class="value">{{ row.scope.createdName }}</span>
          </div>
          <div class="mark-item" style="margin-top: 12px">
            <span class="label label6 flex_c_c">创建时间</span>
            <span class="value">{{ row.scope.createdOn | formatDate }}</span>
          </div>
        </template>
        <span slot="isBOI" :key="row.scope.isBOI" slot-scope="row" :style="{ color: row.scope.isBOI ? '' : '#FE453D' }">
          {{ row.scope.isBOI ? "是" : "否" }}
        </span>
        <span
          slot="isMonthEnd"
          :key="row.scope.isMonthEnd"
          slot-scope="row"
          :style="{ color: row.scope.isMonthEnd ? '' : '#FE453D' }">
          {{ row.scope.isMonthEnd ? "是" : "否" }}
        </span>
        <span
          slot="isSensitiveImporter"
          :key="row.scope.isSensitiveImporter"
          slot-scope="row"
          :style="{ color: row.scope.isSensitiveImporter ? '' : '#FE453D' }">
          {{ row.scope.isSensitiveImporter ? "是" : "否" }}
        </span>
        <template slot="usedBondAmount" slot-scope="row">
          <div class="mark-item">
            <span class="label label6 flex_c_c">总额度</span>
            <span class="value">{{ row.scope.bondTotal || "--" }}</span>
          </div>
          <div class="mark-item" style="margin-top: 12px">
            <span class="label label6 flex_c_c">已使用</span>
            <span
              class="value"
              :style="{
                color:
                  row.scope.usedBondAmount > row.scope.bondTotal
                    ? '#FE453D'
                    : '',
              }">{{ row.scope.usedBondAmount || "--" }}</span>
          </div>
          <div class="mark-item" style="margin-top: 12px">
            <span class="label label6 flex_c_c">未使用</span>
            <span class="value">{{ row.scope.remainingAmount || "--" }}</span>
          </div>
        </template>
        <template slot="inTransitMbl" slot-scope="row">
          {{ row.scope.inTransitMbl }}
          <img v-if=" row.scope.inTransitMbl" style="margin-top: 5px" src="@/assets/images/bill/tax-detail.png" @click="dialogVisible10 = true; rowData = row.scope" />
        </template>
        <template slot="importerDeclare" slot-scope="row">
          {{ row.scope.importerDeclare }}
          <img v-if=" row.scope.importerDeclare" style="margin-top: 5px" src="@/assets/images/bill/tax-detail.png" @click="dialogVisible11 = true; rowData = row.scope" />
        </template>
        <template slot="bondNumber" slot-scope="row">
          <div class="mark-item">
            <span class="label label10 flex_c_c">BOND Number</span>
            <span class="value">{{ row.scope.bondNumber || "--" }}</span>
          </div>
          <div class="mark-item" style="margin-top: 4px">
            <span class="label label10 flex_c_c">Surety Code</span>
            <span class="value">{{ row.scope.suretyCode || "--" }}</span>
          </div>
          <div class="mark-item" style="margin-top: 4px">
            <span class="label label10 flex_c_c">买BOND代理</span>
            <span class="value">{{ row.scope.bondSupplierCode || "--" }}</span>
          </div>
        </template>
        <template slot="mblSeaTotal" slot-scope="row">
          <div class="mark-item">
            <span class="label label5 flex_c_c">海运</span>
            <span class="value">{{ row.scope.mblSeaTotal }}</span>
          </div>
          <div class="mark-item" style="margin-top: 4px">
            <span class="label label5 flex_c_c">空运</span>
            <span class="value">{{ row.scope.mblAirTotal }}</span>
          </div>
          <div class="mark-item" style="margin-top: 4px">
            <span class="label label5 flex_c_c">查验</span>
            <span class="value">{{ row.scope.holdTotal }}</span>
          </div>
          <div class="mark-item" style="margin-top: 4px">
            <span class="label label5 flex_c_c">放行</span>
            <span class="value">{{ row.scope.releaseTotal }}</span>
          </div>
        </template>
        <template slot="cancelDate" slot-scope="row">
          <div class="mark-item">
            <span class="label label6 flex_c_c">是否注销</span>
            <span class="value" :style="`color: ${row.scope.isCancel ? '#FE453D' : ''}`">{{ row.scope.isCancel ? "是" :
              "否" }}</span>
          </div>
          <div class="mark-item" style="margin-top: 12px">
            <span class="label label6 flex_c_c">注销时间</span>
            <span class="value">{{ row.scope.cancelDate | formatDate }}</span>
          </div>
        </template>
        <template slot="yearAuditDeadlineDate" slot-scope="row">
          <div class="mark-item">
            <span class="label label9 flex_c_c">报税截止时间</span>
            <span class="value">{{
              row.scope.bondedDeadlineDate | formatDate
            }}</span>
          </div>
          <div class="mark-item" style="margin-top: 12px">
            <span class="label label9 flex_c_c">年审截止时间</span>
            <span class="value">{{
              row.scope.yearAuditDeadlineDate | formatDate
            }}</span>
          </div>
        </template>
        <template slot="fileNumber" slot-scope="row">
          {{ row.scope.fileNumber }}
          <span class="check_btn" @click="checkFile(row.scope)">查看</span>
        </template>
        <template slot="companyNumber" slot-scope="row">
          {{ row.scope.companyNumber }}
          <span v-if="row.scope.companyNumber > 0" class="check_btn" @click="companyRow(row.scope, true)">查看</span>
          <span
            v-if="row.scope.companyNumber > 0"
            :loading="exportloading"
            class="export_btn"
            @click="exportImporterCompany(row.scope)">导出</span>
        </template>
        <template slot="supplierData" slot-scope="row">
          <div class="mark-item">
            <span class="label label6 flex_c_c">电话</span>
            <span class="value">{{
              row.scope?.supplierData?.phoneNumber || "--"
            }}</span>
          </div>
          <div class="mark-item" style="margin-top: 12px">
            <span class="label label6 flex_c_c">邮箱</span>
            <span class="value">{{
              row.scope?.supplierData?.email || "--"
            }}</span>
            <span
              v-if="row.scope?.supplierData?.email"
              class="check_btn"
              style="margin-left: 6px"
              @click="checkEmailPassDialog(row.scope)">邮箱密码</span>
          </div>
          <div class="mark-item" style="margin-top: 12px">
            <span class="label label6 flex_c_c">备注</span>
            <span class="value">{{
              row.scope?.supplierData?.remark || "--"
            }}</span>
          </div>
        </template>
        <template slot="supplierNames" slot-scope="row">
          <div v-for="(item, index) in row.scope.supplierNames" :key="index" class="supplierNames">
            {{ item }}
          </div>
        </template>
        <template slot="userGroupName" slot-scope="row">
          <span v-if="row.scope?.userGroupName != null && row.scope?.userGroupName != ''" class="group-item">
            {{ row.scope?.userGroupName }}
          </span>
          <!-- <span v-for="(item, index) in row.scope.userGroupNames" :key="index" class="group-item">
            {{ item }}
          </span> -->
        </template>
        <div slot="opt" slot-scope="row" class="tableOpt">
          <el-button type="text" size="small" @click="editRow(row.scope)">修改</el-button>
          <el-button type="text" size="small" @click="handleDelete(row.scope)">删除</el-button>
          <el-button type="text" size="small" @click="supplierRow(row.scope)">分供应商</el-button>
          <el-button type="text" size="small" @click="companyRow(row.scope, false)">分配客户</el-button>
          <!-- <el-button type="text" size="small" @click="optLog(row.scope)">操作记录</el-button> -->
        </div>
        <template #custom-total>
          <div class="custom-total">
            <div class="select">
              已选 <span>{{ selectionItem.length }}</span> 项
            </div>
            <el-popover placement="bottom" popper-class="popper_tooltip" trigger="click" :visible-arrow="false">
              <div class="btn-list">
                <div class="flex_c_c" @click="batchUpdate(0)">更新BOND信息</div>
                <div class="flex_c_c" @click="batchUpdate(1)">更新状态</div>
                <div v-if="active !== null" class="flex_c_c" @click="batchUpdate(2)">
                  更新邮箱密码
                </div>
                <div class="flex_c_c" @click="batchUpdate(3)">更新其它信息</div>
              </div>
              <div slot="reference" class="batch-btn flex_c_c">
                批量更新<img src="@/assets/images/batch-arrow.png" />
              </div>
            </el-popover>
            <el-button slot="reference" class="export-btn flex_c_c" @click="selectexport()">导 出</el-button>
          </div>
        </template>
      </BaseTable>
    </div>
    <AddImporterDialog
      :dialogVisible="dialogVisible1"
      :rowData="rowData"
      :companyOptions="companyDrapdown"
      :userGroupOptions="userGroupOptions"
      :supplierOptions="supplierOptions"
      @cancel="cancel"
      @ok="ok">
    </AddImporterDialog>
    <UpdateBondInfoDialog
      :dialogVisible="dialogVisible2"
      :selectionItem="selectionItem"
      :supplierOptions="supplierOptions"
      @cancel="cancel"
      @ok="ok"></UpdateBondInfoDialog>
    <UpdateStatusDialog :dialogVisible="dialogVisible3" :selectionItem="selectionItem" @cancel="cancel" @ok="ok">
    </UpdateStatusDialog>
    <UpdateEmailPassDialog
      :dialogVisible="dialogVisible4"
      :selectionItem="selectionItem"
      :supplierId="active"
      @cancel="cancel"
      @ok="ok"></UpdateEmailPassDialog>
    <UpadteOtherInfoDialog :dialogVisible="dialogVisible5" :selectionItem="selectionItem" @cancel="cancel" @ok="ok">
    </UpadteOtherInfoDialog>
    <CheckFileDialog :dialogVisible="dialogVisible6" :rowData="rowData" @cancel="cancel"></CheckFileDialog>
    <AllocationSupplierDialog :dialogVisible="dialogVisible7" :rowData="rowData" @cancel="cancel" @ok="ok">
    </AllocationSupplierDialog>
    <OperationLogDrawer :drawer="drawer1" :rowData="rowData" @close="drawer1 = false"></OperationLogDrawer>
    <AllocationCompanyDialog
      :dialogVisible="dialogVisible8"
      :rowData="rowData"
      :companyOptions="companyDrapdown"
      :isCheckCompany="isCheckCompany"
      @cancel="cancel"
      @ok="ok"></AllocationCompanyDialog>
    <CheckEmailPassDialog :dialogVisible="dialogVisible9" :rowData="rowData" @cancel="cancel"></CheckEmailPassDialog>
    <OnLineBillDialog :dialogVisible="dialogVisible10" :rowData="rowData" @cancel="dialogVisible10 = false"></OnLineBillDialog>
    <DeclareHistoryDialog :dialogVisible="dialogVisible11" :rowData="rowData" @cancel="dialogVisible11 = false"></DeclareHistoryDialog>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable.vue')
const BaseFilter = () => import('@/components/filter/BaseFilter1.vue')
import { mapGetters } from 'vuex'
import { myMixins } from '@/mixins'
import AddImporterDialog from './components/AddImporterDialog.vue'
import UpdateStatusDialog from './components/UpdateStatusDialog.vue'
import UpdateBondInfoDialog from './components/UpdateBondInfoDialog.vue'
import UpadteOtherInfoDialog from './components/UpadteOtherInfoDialog.vue'
import UpdateEmailPassDialog from './components/UpdateEmailPassDialog.vue'
import DeclareHistoryDialog from './components/DeclareHistoryDialog.vue'
import OnLineBillDialog from './components/OnLineBillDialog.vue'

import AllocationSupplierDialog from './components/AllocationSupplierDialog.vue'
import OperationLogDrawer from './components/OperationLogDrawer.vue'
import CheckFileDialog from './components/CheckFileDialog.vue'
import CheckEmailPassDialog from './components/CheckEmailPassDialog.vue'
import AllocationCompanyDialog from './components/AllocationCompanyDialog.vue'
import { getImporterPageList, deleteImporter, getSupplierDropDownList } from '@/api/system'
import config from '@/utils/config'
import { derive } from '@/utils/common'
// import utils from '../../utils/utils.js'
// import sessionHelper from '@/utils/session'
export default {
  name: 'Importer',
  components: {
    BaseTable,
    BaseFilter,
    AddImporterDialog,
    UpdateStatusDialog,
    UpdateBondInfoDialog,
    UpadteOtherInfoDialog,
    UpdateEmailPassDialog,
    CheckFileDialog,
    AllocationSupplierDialog,
    OperationLogDrawer,
    AllocationCompanyDialog,
    CheckEmailPassDialog,
    OnLineBillDialog,
    DeclareHistoryDialog
  },
  filters: {
    formatDate(date) {
      return date ? date.slice(0, date.length - 9) : '--'
    }
  },
  mixins: [myMixins],
  data() {
    return {
      config,
      loading: false,
      active: null,
      tabList: [],
      height: 0,
      pager: {
        pageIndex: 1,
        pageSize: 20
      },
      tableData: {
        columns: [],
        total: 0,
        mutiCheck: true,
        mutiFixed: 'left'
      },
      selectionItem: [],
      sortable: {},
      listStatusMap: {
        1: '买磅中',
        2: '未备案',
        3: '注销中',
        4: '已备案',
        5: '已失效',
        7: '已超磅',
        8: '已注销',
        9: '呆滞'
      },
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible6: false,
      dialogVisible7: false,
      dialogVisible8: false,
      dialogVisible9: false,
      dialogVisible10: false,
      dialogVisible11: false,
      drawer1: false,
      rowData: {},
      userGroupOptions: [],
      supplierOptions: [],
      isCheckCompany: false,
      exportloading: false,
      isActive: false,
      filterList: {
        status: [],
        belong: '',
        companyIds: '',
        registerDate: [],
        effectiveDate: [],
        closeDate: [],
        createdOn: [],
        bondedDeadlineDate: [],
        yearAuditDeadlineDate: [],
        einNo: '',
        isBOI: '',
        isMonthEnd: '',
        isSensitiveImporter: '',
        isCancel: '',
        suretyCode: '',
        bondSupplierId: '',
        taxNo: '',
        userGroupId: '',
        isAssigned: '',
        email: '',
        contacts: []
      },
      contactsInput: '', // 专门用于绑定输入框的字符串
      // userInfo: sessionHelper('get', 'userInfo'),
      searchVal: ''
    }
  },
  computed: {
    ...mapGetters(['companyDrapdown']),
    fileds() {
      const arr = [
        {
          filed: 'status',
          label: '状态',
          width: 100,
          isSort: true,
          isCustom: true
        },
        {
          filed: 'belong',
          label: '归属',
          width: 160,
          isCustom: true
        },
        {
          filed: 'name',
          label: '进口商名称',
          width: 200,
          align: 'left'
        },
        {
          filed: 'taxNo',
          label: 'EIN NO',
          width: 150,
          isSort: true
        },
        {
          filed: 'countryName',
          label: '地址',
          width: 520,
          isCustom: true
        },
        {
          filed: 'contact',
          label: '法人',
          width: 120
        },
        {
          filed: 'registerDate',
          label: '注册时间',
          width: 120,
          formatter: (row) =>
            row.registerDate
              ? row.registerDate.slice(0, row.registerDate.length - 9)
              : '--',
          isSort: true
        },
        {
          filed: 'effectiveDate',
          label: '生效日期',
          width: 120,
          formatter: (row) =>
            row.effectiveDate
              ? row.effectiveDate.slice(0, row.effectiveDate.length - 9)
              : '--',
          isSort: true
        },
        {
          filed: 'closeDate',
          label: '截止日期',
          width: 120,
          formatter: (row) =>
            row.closeDate
              ? row.closeDate.slice(0, row.closeDate.length - 9)
              : '--',
          isSort: true
        },
        {
          filed: 'isSensitiveImporter',
          label: '是否敏感',
          width: 110,
          isSort: true,
          isCustom: true
        },
        {
          filed: 'usedBondAmount',
          label: 'BOND额度(USD)',
          width: 200,
          isCustom: true
        },
        {
          filed: 'inTransitMbl',
          label: '在途提单',
          width: 150,
          isCustom: true
        },
        {
          filed: 'importerDeclare',
          label: '税则数量',
          width: 150,
          isCustom: true
        },
        {
          filed: 'bondNumber',
          label: 'BOND信息',
          width: 240,
          isCustom: true
        },
        {
          filed: 'mblSeaTotal',
          label: '提单统计',
          width: 160,
          isCustom: true
        },
        {
          filed: 'inspectionRate',
          label: '查验率',
          width: 80,
          formatter: (row) =>
            row.inspectionRate ? `${row.inspectionRate} %` : '0 %'
        },
        {
          filed: 'remark',
          label: '备注',
          width: 200
        },
        {
          filed: 'createdOn',
          label: '创建',
          width: 200,
          isCustom: true
        },
        {
          filed: 'isBOI',
          label: 'BOI是否',
          width: 100,
          isSort: true,
          isCustom: true
        },
        {
          filed: 'isMonthEnd',
          label: '月结是否',
          width: 110,
          isSort: true,
          isCustom: true
        },
        {
          filed: 'isActived',
          label: '是否禁用',
          width: 110,
          isSort: true,
          formatter: (row) =>
            row.isActived ? `是` : '否'
        },
        {
          filed: 'cancelDate',
          label: '注销',
          width: 170,
          isCustom: true
        },
        {
          filed: 'yearAuditDeadlineDate',
          label: '其他时间',
          width: 190,
          isCustom: true
        },
        {
          filed: 'fileNumber',
          label: '附件数量',
          width: 120,
          isCustom: true
        },
        {
          filed: 'companyNumber',
          label: '分配客户数',
          width: 140,
          isCustom: true
        },
        // {
        //   filed: 'userGroupName',
        //   label: '组别',
        //   width: 120,
        //   isCustom: true
        // },
        {
          filed: 'opt',
          label: '操作',
          width: '120',
          fixed: 'right',
          isCustom: true
        }
      ]
      if (this.active !== null) {
        arr.splice(6, 0, {
          filed: 'supplierData',
          label: '供应商信息',
          width: 320,
          isCustom: true
        })
      } else {
        arr.splice(6, 0, {
          filed: 'supplierNames',
          label: '供应商',
          width: 120,
          isCustom: true
        })
      }
      return arr
    }
  },
  async mounted() {
    if (!(this.companyDrapdown && this.companyDrapdown.length > 0)) {
      await this.$store.dispatch('getCompanyDrapdown')
    }
    this.height = document.querySelector('.data').offsetHeight - 42
    await this.getList(this.pager)
    this.getSupplierDropDownList()
  },
  methods: {
    changeType(value) {
      this.active = value
      const param = {
        pageIndex: 1,
        pageSize: this.pager.pageSize
      }
      this.pager = param
      this.getList(param)
    },
    async getSupplierDropDownList() {
      try {
        const param = {
        scopValue: 18
      }
        const res = await getSupplierDropDownList(param)
        if (res.success) {
          this.supplierOptions = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getList(params) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            supplierId: this.active,
            ...this.sortable,
            ...this.formatterFilter(),
            search: this.searchVal || undefined
          }
        }
        const res = await getImporterPageList(params)
        this.loading = false
        if (res.success) {
          const { tabNumer, total, list } = res.data
          this.tabList = tabNumer
          this.tableData.total = total
          this.tableData.columns = list
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    initList() {
      const param = {
        pageIndex: 1,
        pageSize: this.pager.pageSize
      }
      this.pager = param
      this.getList(param)
    },
    handlePageChange(page) {
      this.pager = page
      this.getList(page)
    },
    handleSelectionChange(items) {
      this.selectionItem = items
    },
    sortChange(orderObj) {
      this.sortable = {
        sortField: orderObj.prop,
        sortBy: orderObj.order === 'asc' ? 0 : 1
      }
      this.getList(this.pager)
    },
    cancel() {
      this.dialogVisible1 = false
      this.dialogVisible2 = false
      this.dialogVisible3 = false
      this.dialogVisible4 = false
      this.dialogVisible5 = false
      this.dialogVisible6 = false
      this.dialogVisible7 = false
      this.dialogVisible8 = false
      this.dialogVisible9 = false
      this.rowData = {}
    },
    ok() {
      this.dialogVisible1 = false
      this.dialogVisible2 = false
      this.dialogVisible3 = false
      this.dialogVisible4 = false
      this.dialogVisible5 = false
      this.dialogVisible7 = false
      this.dialogVisible8 = false
      this.rowData = {}
      this.getList(this.pager)
    },
    editRow(row) {
      this.rowData = row
      this.dialogVisible1 = true
    },
    handleDelete(row) {
      this.$confirm('此操作将删除该进口商信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteImporter({ importerId: row.id }).then((res) => {
            if (res.success) {
              this.$message.success('删除成功')
              this.initList()
            } else {
              this.$message.error(res.errorMessage)
            }
          })
        })
        .catch(() => { })
    },
    batchUpdate(v) {
      if (!this.selectionItem.length) {
        this.$message.error('请选择进口商')
        return
      }
      !v && (this.dialogVisible2 = true)
      v === 1 && (this.dialogVisible3 = true)
      v === 2 && (this.dialogVisible4 = true)
      v === 3 && (this.dialogVisible5 = true)
    },
    async selectexport() {
      if (!this.selectionItem.length) {
        this.$message.error('请选择进口商')
        return
      }
      const params = {
        importerIds: this.selectionItem.map((a) => a.id)
      }
      await derive('Importer/exportImporter', 'post', params, null)
    },
    checkFile(row) {
      this.rowData = row
      this.dialogVisible6 = true
    },
    supplierRow(row) {
      this.rowData = row
      this.dialogVisible7 = true
    },
    companyRow(row, bool) {
      this.isCheckCompany = bool
      this.rowData = row
      this.dialogVisible8 = true
    },
    optLog(row) {
      this.rowData = row
      this.drawer1 = true
    },
    formatterFilter() {
      const { filterList } = this // 解构减少重复引用
      // 统一处理空值逻辑
      const val = (v) =>
        v !== '' && v !== undefined && v !== null ? v : undefined
      const arr = (a) => (a?.length ? a : undefined)
      const dateRange = (d, idx) =>
        arr(d) && d.length > idx ? d[idx] : undefined
      // 复用分割逻辑（可提取为工具函数）
      const parseContacts = (input) => {
        if (!input?.trim()) return undefined
        return input
          .split(/；|;|，|,/) // 支持中英文分号/逗号
          .map(s => s.trim())
          .filter(s => s) // 过滤空值
      }
      return {
        status: arr(filterList.status),
        companyIds: val(filterList.companyIds),
        einNo: val(filterList.einNo),
        userGroupId: val(filterList.userGroupId),
        isBOI: val(filterList.isBOI),
        isActived: val(filterList.isActived),
        isMonthEnd: val(filterList.isMonthEnd),
        isSensitiveImporter: val(filterList.isSensitiveImporter),
        isCancel: val(filterList.isCancel),
        isAssigned: val(filterList.isAssigned),
        suretyCode: val(filterList.suretyCode),
        bondSupplierId: val(filterList.bondSupplierId),
        taxNo: val(filterList.taxNo),
        email: val(filterList.email),
        contacts: parseContacts(this.contactsInput),
        // 日期范围处理
        registerStartDate: dateRange(filterList.registerDate, 0),
        registerEndDate: dateRange(filterList.registerDate, 1),
        effectiveStartDate: dateRange(filterList.effectiveDate, 0),
        effectiveEndDate: dateRange(filterList.effectiveDate, 1),
        closeStartDate: dateRange(filterList.closeDate, 0),
        closeEndDate: dateRange(filterList.closeDate, 1),
        createdStartOn: dateRange(filterList.createdOn, 0),
        createdEndOn: dateRange(filterList.createdOn, 1),
        bondedDeadlineStartDate: dateRange(filterList.bondedDeadlineDate, 0),
        bondedDeadlineEndDate: dateRange(filterList.bondedDeadlineDate, 1),
        yearAuditDeadlineStartDate: dateRange(
          filterList.yearAuditDeadlineDate,
          0
        ),
        yearAuditDeadlineEndDate: dateRange(
          filterList.yearAuditDeadlineDate,
          1
        ),
        belong: val(filterList.belong)
      }
    },
    async exportData() {
      await derive('Importer/exportImporter', 'post', this.formatterFilter(), null)
    },
    sendFilter() {
      const hasContacts = !!((this.contactsInput || '').trim()) && (this.contactsInput.split(/；|;|，|,/).map(s => s.trim()).filter(s => s).length > 0)
      if (
        this.filterList.status.length ||
        this.filterList.registerDate.length ||
        this.filterList.effectiveDate.length ||
        this.filterList.closeDate.length ||
        this.filterList.createdOn.length ||
        this.filterList.bondedDeadlineDate.length ||
        this.filterList.yearAuditDeadlineDate.length ||
        this.filterList.companyIds ||
        this.filterList.einNo ||
        this.filterList.userGroupId ||
        this.filterList.isActived !== '' ||
        this.filterList.isBOI !== '' ||
        this.filterList.isMonthEnd !== '' ||
        this.filterList.isSensitiveImporter !== '' ||
        this.filterList.isCancel !== '' ||
        this.filterList.suretyCode ||
        this.filterList.bondSupplierId ||
        this.filterList.taxNo ||
        this.filterList.belong !== '' ||
        this.filterList.email !== '' ||
        hasContacts
      ) {
        this.isActive = true
      } else {
        this.isActive = false
      }
      const params = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = params
      this.getList(params)
    },
    reset() {
      this.contactsInput = ''
      this.filterList.contacts = []
      this.filterList = this.$options.data().filterList
      this.isActive = false
    },
    checkEmailPassDialog(row) {
      this.rowData = row
      this.dialogVisible9 = true
    },
    changeIsAssigned(v) {
      this.filterList.isAssigned = v
      this.initList()
    },
    formatStatus(row) {
      return this.config.importerStatusOptions.find(
        (a) => a.value === row.status
      )?.label
    },
    exportImporterCompany(row) {
      this.exportloading = true
      try {
        const params = {
          importerId: row.id
        }
        derive('Importer/exportImporterCompany?' + '?importerId=' + row.id, 'get', params, null)
      } catch (error) {
        console.error('错误信息', error)
      }
      this.exportloading = false
    }
  }
}
</script>

<style lang="less" scoped>
.content {
    width: 100%;
    padding: 0 10px;
    height: 100%;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;

    .tabItem {
      padding: 15px 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      cursor: pointer;
      box-sizing: border-box;

      &.active {
        color: #142e79;
      }
    }

    .search {
      position: relative;
      display: flex;
      width: 260px;

      .input-search {
        width: 230px;
        height: 30px !important;

        /deep/ .el-input__inner {
          height: 100%;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }

        &:deep(.el-input__suffix) {
          height: 30px;
          line-height: 30px;
          top: -4px;
        }
      }

      .btn-search {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border: 1px solid #dbe4f2;
        border-left: 0;
        border-radius: 0 4px 4px 0;
        box-sizing: border-box;
        cursor: pointer;
      }
    }

    .header-opt {
      display: flex;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;

      &>div+div {
        margin-left: 10px;
      }

      .filter-tab {
        display: flex;
        align-items: center;
        border-radius: 2px;
        overflow: hidden;

        .tab-item {
          width: 88px;
          height: 30px;
          background: #f7f7f7;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #0f0c0c;
          cursor: pointer;

          &:first-child {
            width: 60px;
          }

          &.active {
            background: #142e79;
            color: #ffffff;
          }
        }
      }

      .add {
        width: 80px;
        height: 30px;
        background: #142e79;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
        margin-right: 10px;
      }

      i {
        font-size: 16px;
        margin-right: 4px;
      }
    }
  }

  .data {
    width: 100%;
    height: calc(100% - 60px);

    .tableOpt {
      display: flex;
      flex-direction: column;

      button {
        margin: 0;
        margin-top: -6px;
        font-size: 13px;
        display: inline-block;
      }
    }

    // .tableOpt {
    //   display: flex;
    //   flex-wrap: wrap; // 允许换行
    //   .button1 {
    //     margin: 0;
    //     flex:50%; // 每个按钮占 50% 宽度
    //    }
    //  }

    .status {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #fe453d;

      &::before {
        content: "";
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-right: 4px;
        background: #fe453d;
      }

      &.status4 {
        color: #2395f3;

        &::before {
          background: #2395f3;
        }
      }
    }

    .belong {
      width: 50px;
      height: 20px;
      border-radius: 4px 4px 4px 4px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      margin: 0 auto;

      &.belong0 {
        background: #e6fff4;
        color: #03c645;
      }

      &.belong1 {
        background: #ffe3e2;
        color: #fe453d;
      }
    }

    .address-row {
      display: flex;

      .mark-item+.mark-item {
        margin-left: 10px;
      }
    }

    .mark-item {
      display: flex;
      align-items: center;

      .label {
        height: 24px;
        background: #e6edff;
        border-radius: 4px 4px 4px 4px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: #142e79;
        margin-right: 5px;

        &.label5 {
          min-width: 50px;
        }

        &.label6 {
          min-width: 60px;
        }

        &.label9 {
          min-width: 90px;
        }

        &.label10 {
          min-width: 100px;
        }
      }
    }

    .check_btn {
      display: inline-block;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #2395f3;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #2395f3;
      cursor: pointer;
      box-sizing: border-box;
      padding: 0 10px;
      box-sizing: border-box;
    }

    .export_btn {
      display: inline-block;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #03c645;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #03c645;
      cursor: pointer;
      box-sizing: border-box;
      padding: 0 10px;
      box-sizing: border-box;
    }

    .group-item {
      display: inline-block;
      min-width: 50px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background: #e6fff4;
      border-radius: 4px 4px 4px 4px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #03c645;
      padding: 0 8px;
      box-sizing: border-box;
    }

    .supplierNames {
      width: 50px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      background: #e6fff4;
      border-radius: 4px 4px 4px 4px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #03c645;
      margin: 0 auto;

      &+.supplierNames {
        margin-top: 6px;
      }
    }

    .custom-total {
      position: absolute;
      display: flex;
      align-items: center;
      height: 40px;
      z-index: 10;

      .select {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #666666;

        span {
          color: #142e79;
        }
      }

      .batch-btn {
        width: 114px;
        height: 30px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #142e79;
        box-sizing: border-box;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #142e79;
        margin-left: 20px;
        cursor: pointer;

        img {
          margin-left: 5px;
        }
      }

      .export-btn {
        width: 80px;
        height: 30px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #199689;
        box-sizing: border-box;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #199689;
        margin-left: 20px;
        cursor: pointer;

        img {
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
<style lang="less">
.btn-list {
  &>div {
    width: 120px;
    height: 30px;
    background: #2395f3;
    border-radius: 4px 4px 4px 4px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;

    &+div {
      margin-top: 10px;
    }
  }
}
</style>
